// Список заказов (/orders/): удаление заказа с подтверждением.
// Кнопка-корзина в карточке только запоминает, какой заказ удаляем, и открывает
// общий попап order-delete (открытие — Popup.js по data-popup-open). Само удаление
// уходит на сервер с кнопки подтверждения; после успеха просто перезагружаем список.

import { showAlert } from "../Popup/Popup-alert.js";

const ORDER_MID = 3; // mod_order в таблице modules

const list = document.querySelector(".orders__list");
if (list) {
	initOrdersDelete(list);
	initOrdersFilter(list);
}
initAccountDelete();

// Фильтр по статусу. Список целиком уже в разметке, поэтому просто прячем лишние
// карточки — без похода на сервер. Выбранный статус держим в адресе (?status=N):
// удаление заказа перезагружает страницу, и фильтр должен пережить перезагрузку.
function initOrdersFilter(root) {
	const select = document.querySelector("[data-orders-filter]");
	if (!select) return;

	const items = [...root.querySelectorAll(".orders__item")];

	const empty = document.createElement("p");
	empty.className = "orders__filter-empty";
	empty.hidden = true;
	empty.textContent = "Заказов с таким статусом нет";
	root.after(empty);

	const apply = (status, pushUrl) => {
		let shown = 0;
		items.forEach((li) => {
			const match = !status || li.dataset.status === status;
			li.hidden = !match;
			if (match) shown++;
		});
		empty.hidden = shown > 0;

		if (!pushUrl) return;
		const url = new URL(location.href);
		if (status) url.searchParams.set("status", status);
		else url.searchParams.delete("status");
		history.replaceState(null, "", url);
	};

	// статус из адреса — только если такой пункт есть в списке
	const fromUrl = new URL(location.href).searchParams.get("status") || "";
	if (fromUrl && [...select.options].some((o) => o.value === fromUrl)) select.value = fromUrl;

	select.addEventListener("change", () => apply(select.value, true));
	apply(select.value, false);
}

function initOrdersDelete(root) {
	const popupNumber = document.querySelector("[data-order-delete-number]");
	const confirmBtn = document.querySelector("[data-order-delete-confirm]");
	if (!confirmBtn) return;

	let pendingId = null;

	root.querySelectorAll(".orders__item-remove").forEach((btn) => {
		btn.addEventListener("click", () => {
			pendingId = btn.dataset.orderId || null;
			// номер заказа в заголовке попапа: «Удалить заказ №123?»
			if (popupNumber) {
				const number = btn.dataset.orderNumber || "";
				popupNumber.textContent = number ? ` №${number}` : "";
			}
		});
	});

	confirmBtn.addEventListener("click", () => {
		if (pendingId) deleteOrder(pendingId, confirmBtn);
	});
}

const AUTH_MID = 2;

function initAccountDelete() {
	const btn = document.querySelector("[data-account-delete-confirm]");
	if (!btn) return;
	btn.addEventListener("click", () => deleteAccount(btn));
}

async function deleteAccount(btn) {
	btn.disabled = true;
	try {
		const data = new FormData();
		data.set("action", "deleteAccount");
		const res = await fetch(`/ajax.php?mid=${AUTH_MID}`, { method: "POST", body: data });
		const json = await res.json();
		if (json.success) {
			window.location.href = json.redirect || "/";
			return;
		}
		showAlert(json.error || "Не удалось удалить кабинет");
	} catch (e) {
		console.error("[orders] ошибка удаления кабинета:", e);
		showAlert("Не удалось удалить кабинет");
	}
	if (window.popup) window.popup.close("account-delete");
	btn.disabled = false;
}

async function deleteOrder(orderId, btn) {
	btn.disabled = true;
	try {
		const data = new FormData();
		data.set("action", "deleteOrder");
		data.set("order_id", orderId);
		const res = await fetch(`/ajax.php?mid=${ORDER_MID}`, { method: "POST", body: data });
		const json = await res.json();
		if (json.success) { window.location.reload(); return; }
		console.warn("[orders] заказ не удалён:", json.error);
		showAlert(json.error || "Не удалось удалить заказ");
	} catch (e) {
		console.error("[orders] ошибка удаления заказа:", e);
		showAlert("Не удалось удалить заказ");
	}
	if (window.popup) window.popup.close("order-delete");
	btn.disabled = false;
}
